import React, { useRef, useState } from 'react';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { List } from './components';
import { Badge, Button, Col, Row, Tabs, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import './MasterData.css';

const TAB_KEYS = ['CN', 'TQL', 'DHK', 'TUYEN', 'METER_NAME', 'METER_SIZE'];

const TYPE_LABEL = {
  CN: 'Chi nhánh',
  TQL: 'Tổ quản lý',
  DHK: 'Đồng hồ khối',
  TUYEN: 'Tuyến',
  METER_NAME: 'Tên đồng hồ',
  METER_SIZE: 'Cỡ đồng hồ'
};

const MasterDataPage = () => {
  const [active, setActive] = useState('CN');
  const [counts, setCounts] = useState({});
  const listRef = useRef(null);
  const { masterData } = usePermission();

  if (!masterData.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  const handleCountChange = (type, count) => {
    setCounts((prev) => ({ ...prev, [type]: count }));
  };

  const tabItems = TAB_KEYS.map((key) => ({
    key,
    label: (
      <span>
        {TYPE_LABEL[key]}
        {counts[key] != null && (
          <Badge
            count={counts[key]}
            showZero
            style={{ backgroundColor: '#0284c7', marginLeft: 6, fontSize: 11 }}
            overflowCount={9999}
          />
        )}
      </span>
    )
  }));

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Danh mục quản lý', path: '/management-structure' }]}
        />
      </div>

      {/* Title + Add button */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
        <Col>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Danh mục quản lý
          </Typography.Title>
        </Col>
        <Col>
          {masterData.create && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => listRef.current?.openCreate()}
              style={{ backgroundColor: '#0284c7', borderColor: '#0284c7', height: 36 }}>
              Thêm {TYPE_LABEL[active]}
            </Button>
          )}
        </Col>
      </Row>

      <Tabs activeKey={active} onChange={setActive} items={tabItems} className="master-data-tabs" />

      {/* key prop ensures full remount on tab change → clean state */}
      <List ref={listRef} key={active} activeType={active} onCountChange={handleCountChange} />
    </ContainerBody>
  );
};

export default MasterDataPage;
